const wasteGlassBottle = () => import('../views/nutrilite/waste-glass-bottle2/wasteGlassBottle')
const relayEvent = () => import('../views/nutrilite/relayevent/relayevent')
const tripleEyeCare = () => import('../views/triple-eye-care/tripleEyeCare')
const selfDiagnosis = () => import('../views/nutrilite/self-diagnosis/index')
const a7070_glister = () => import('../views/nutrilite/a7070-glister')

export default [
  {
    path: '/old/nutrilite/waste-glass-bottle',
    name: 'waste-glass-bottle',
    component: wasteGlassBottle
  },
  {
    path: '/old/nutrilite/relay-event',
    name: 'relayEvent',
    component: relayEvent
  },
  {
    path: '/old/triple-eye-care',
    name: 'triple-eye-care',
    component: tripleEyeCare
  },
  {
    path: '/nutrilite/self-diagnosis',
    name: 'self-diagnosis',
    component: selfDiagnosis
  },
  {
    path: '/a7070-glister',
    name: 'a7070-glister',
    component: a7070_glister
  },
]